'use client';

import { useEffect } from 'react';

const DisableMobileZoom = () => {
  useEffect(() => {
    const preventGesture = (event: Event): void => {
      event.preventDefault();
    };

    const preventMultiTouch = (event: TouchEvent): void => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    };

    document.addEventListener('gesturestart', preventGesture, { passive: false });
    document.addEventListener('gesturechange', preventGesture, { passive: false });
    document.addEventListener('gestureend', preventGesture, { passive: false });

    document.addEventListener('touchmove', preventMultiTouch, { passive: false });

    return () => {
      document.removeEventListener('gesturestart', preventGesture);
      document.removeEventListener('gesturechange', preventGesture);
      document.removeEventListener('gestureend', preventGesture);

      document.removeEventListener('touchmove', preventMultiTouch);
    };
  }, []);

  return null;
};

export default DisableMobileZoom;
